import { PopupMessageBase, PopupMessageType } from "../../../Utils/PopupMessage";
import { IUpdatableItem } from "../../../Utils/UpdatableItemManager";
import { Game, eFontAsset } from "../../../Game";
import { TIMER, Gameplay, eBatchGroup } from "../../Gameplay";



export class ScorePopup extends PopupMessageBase implements IUpdatableItem {
    private static _MSG_TYPE: PopupMessageType;
    private static _ENTITY_CLONE_TEMP: pc.Entity;

    private _entity: pc.Entity;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor() {
        super();

        if (!ScorePopup._ENTITY_CLONE_TEMP) {
            ScorePopup._ENTITY_CLONE_TEMP = this.createEntity();
            this._entity = ScorePopup._ENTITY_CLONE_TEMP;

            ScorePopup._MSG_TYPE = new PopupMessageType(2, 800, pc.CubicOut);
        }
        else {
            this._entity = ScorePopup._ENTITY_CLONE_TEMP.clone();
        }

        Game.app.root.addChild(this._entity);
        this._entity.enabled = false;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    show(x: number, y: number, z: number, text: string): ScorePopup {
        this._entity.element.text = text;
        this._entity.setPosition(x, y, z);
        this._entity.enabled = true;

        super.showMessage(x, y, z, ScorePopup._MSG_TYPE, TIMER);

        return this;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    update(): boolean {
        return super.update();
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    release(): IUpdatableItem {
        super.release();
        this._entity.enabled = false;

        return this;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    protected updateContainer(x: number, y: number): void {
        this._entity.setPosition(x, y, this._startPos.z);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private createEntity(): pc.Entity {
        let e = new pc.Entity("scorePopup");
        e.enabled = false;

        // Pridat text element
        e.addComponent(pc.eCompomentType.element, {
            type: pc.ELEMENTTYPE_TEXT,
            fontSize: 0.3,
            fontAsset: Game.app.assets.find(eFontAsset.default, pc.eAssetType.font).id,
            autoWidth: true,
            autoHeight: true,
            pivot: [0.5, 0],
            batchGroupId: Gameplay.BATCH_GROUP_ID[eBatchGroup.popupMessages]
        });

        e.element.shadowColor.set(0, 0, 0, 1);
        e.element.shadowOffset.set(1, 0);

        return e;
    }
}